/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Automation_Run_Retry_FailedInputs */

const en_automation_run_retry_failed = /** @type {(inputs: Automation_Run_Retry_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not retry this run.`)
};

const pt_br2_automation_run_retry_failed = /** @type {(inputs: Automation_Run_Retry_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não foi possível tentar esta execução novamente.`)
};

/**
* | output |
* | --- |
* | "Could not retry this run." |
*
* @param {Automation_Run_Retry_FailedInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const automation_run_retry_failed = /** @type {((inputs?: Automation_Run_Retry_FailedInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automation_Run_Retry_FailedInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_automation_run_retry_failed(inputs)
	return pt_br2_automation_run_retry_failed(inputs)
});